import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';


@Injectable()
export class UploadXmlFileService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) { }


  // public getUploadFile(fileName) {
  //   // var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded'});
  //   //return this.httpClient.post(this.rootUrl+'/api/UploadXmlFile/Upload',xElement,{ headers: reqHeader });


  //   //var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded'});
  //   //return this.httpClient.post(this.rootUrl+'/api/UploadXmlFile/Upload',fileName);
  //   var reqHeader = new HttpHeaders(
  //     {
  //       'Content-Type': 'multipart/form-data',
  //       'File': fileName
  //     });
  //   return this.httpClient.post(this.rootUrl + '/api/UploadXmlFile/Upload', { headers: reqHeader });
  // }

  setDataCompletitions(flag: boolean, fileLoadDataResult: any, compareOperation: string, compareSessionId: string) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/UploadXmlFile/UpdateCompleteData?flag=${flag}&compareOperation=${compareOperation}&compareSessionId=${compareSessionId}`, fileLoadDataResult, { headers });
  }
  getCustomerDetail(customerId: string) {
    return this.httpClient.get(`${this.rootUrl}/api/UploadXmlFile/GetCustomerDetail?customerId=${customerId}`);
  }
  getBank() {
    return this.httpClient.get(`${this.rootUrl}/api/UploadXmlFile/GetListBank`);
  }
  getBankAsStrings() {
    return this.httpClient.get(`${this.rootUrl}/api/UploadXmlFile/GetListBankAsStrings`);
  }  
  // getDownloadFile(fileName: string) {
  //   return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/GetDownloadFile?fileName=${fileName}`, { responseType: 'blob' });
  // }
  getDownloadFile(fileName: string, fileId: number, customerId: string) {
    return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/GetDownloadFile?fileName=${fileName}&fileId=${fileId}&customerId=${customerId}`, { responseType: 'blob' });
  }
  getMsvDDL(customerId: string) {
    return this.httpClient.get(`${this.rootUrl}/api/UploadXmlFile/GetMsvDDL?customerId=${customerId}`);
  }

  getManualMasavDownloadFile(customerId: string) {
    return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/GetManualMasavDownloadTemplateFile?customerId=${customerId}`, { responseType: 'blob' });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/upload-xml-file.service.ts